const styles = {
  container: {
    mt: 1.5,
    p: 2,
    borderRadius: "10px",
    border: `1px solid #E0E0E0`,
    position: "relative",
  },
  close: {
    position: "absolute",
    right: 2,
    top: 2,
    m: 1,
    width: 20,
    height: 20,
    fontSize: 14,
  },
};

export default styles;
